import { fmtMoney } from "@/lib/format";
import { Trophy, AlertCircle } from "lucide-react";

const KPI = ({ label, value, sub, tone = "text-white", testId }) => (
  <div className="bg-[#141414] border border-[#262626] rounded-sm p-5" data-testid={testId}>
    <div className="kpi-label">{label}</div>
    <div className={`font-mono-data text-2xl md:text-3xl tracking-tight mt-1.5 ${tone}`}>{value}</div>
    {sub && <div className="text-xs text-[#737373] mt-1">{sub}</div>}
  </div>
);

export const ManagementSummary = ({ summary }) => {
  const s = summary || {};
  return (
    <div className="space-y-4" data-testid="management-summary">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <KPI label="Pipeline Value" value={fmtMoney(s.total_pipeline_value)} testId="mgmt-pipeline"/>
        <KPI label="Active Opportunities" value={s.active_opportunities ?? 0} testId="mgmt-active"/>
        <KPI label="Proposals $" value={fmtMoney(s.total_proposals_value)} testId="mgmt-proposals"/>
        <KPI label="Wins $" value={fmtMoney(s.total_wins_value)} tone="text-[#32D74B]" testId="mgmt-wins"/>
        <KPI label="Win Rate" value={`${s.overall_win_rate ?? 0}%`} testId="mgmt-winrate"/>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="bg-[#141414] border border-[#262626] rounded-sm p-5 flex items-center gap-4">
          <div className="w-10 h-10 rounded-sm border border-[#32D74B]/40 bg-[#32D74B]/10 flex items-center justify-center">
            <Trophy className="w-5 h-5 text-[#32D74B]" strokeWidth={1.7}/>
          </div>
          <div>
            <div className="kpi-label">Top Performing BDR</div>
            <div className="font-display text-xl text-white tracking-tight mt-0.5" data-testid="mgmt-top-bdr">{s.top_performing_bdr || "—"}</div>
          </div>
        </div>
        <div className="bg-[#141414] border border-[#262626] rounded-sm p-5 flex items-start gap-4">
          <div className="w-10 h-10 rounded-sm border border-[#FF453A]/40 bg-[#FF453A]/10 flex items-center justify-center shrink-0">
            <AlertCircle className="w-5 h-5 text-[#FF453A]" strokeWidth={1.7}/>
          </div>
          <div className="flex-1">
            <div className="kpi-label">Underperforming BDRs</div>
            <div className="mt-1 flex flex-wrap gap-2" data-testid="mgmt-under-bdrs">
              {(s.underperforming_bdrs || []).length === 0
                ? <span className="text-sm text-[#525252]">None flagged</span>
                : s.underperforming_bdrs.map((b, i) => (
                  <span key={i} className="px-2 py-0.5 rounded-sm border border-[#FF453A]/40 bg-[#FF453A]/10 text-[#FF453A] text-xs font-mono-data tracking-wider uppercase">{b}</span>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagementSummary;
